export const STEPS_LIST: string[] = ['Complete the information', 'OTP verification', 'Save your Id and Secret'];
